import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=3404d5d1"
import script from "./mobileFooter.vue?vue&type=script&lang=js"
export * from "./mobileFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports